<template>
  <v-container grid-list-xl class="pa-5">
    <v-alert
      v-if="is_premium"
      dense text
      class="body-2 mb-5 pb-5"
      type="info"
    >
      Berikut ini merupakan daftar atribut yang nantinya akan dimiliki
      pengguna
      <b>Klik tombol tambah (+)</b> untuk menambah atribut pengguna baru.
    </v-alert>
    <m-card-list
      two-line
      title="Atribut Anggota"
      label-cari="Cari Atribut Anggota"
      search
      :add="isCan('atribut.store')"
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
            search => {
              textSearch = search;
              load();
            }
          "
      @change:page="
            pg => {
              cp = pg;
              load();
            }
          "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>{{ pVal(item, "nama") }}</td>
          <td>
            <ul v-if="item.tipe === 'Pilihan'" type="circle">
              <li v-for="item in item.default_value" :key="item.atribut_id">
                {{ item }}
              </li>
            </ul>
            <span v-else>
                  {{ pVal(item, "default_value") | toStr }}
                </span>
          </td>
          <td>
            <m-menu
              left
              style="float:right"
              :items="more_menu"
              :object="item"
            />
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[0].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "nama") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              {{ headers[1].text }}
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item, "default_value") | toStr }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Aksi
            </div>
            <div class="v-data-table__mobile-row__cell">
              <m-menu
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </div>
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from "@/tools";
import ChangeDlg from "../components/Form.vue";
import BlockCard from "@/components/BlockCard";

export default {
  components: {
    ChangeDlg,
    BlockCard
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: "Jenis Atribut", align: "left", value: "nama" },
        { text: "Pilihan Atribut", align: "left", value: "value" },
        { text: "", sortable: false }
      ],
      more_menu: [
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: () => isCan("atribut.update")
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: () => isCan("atribut.destroy")
        }
      ]
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("atribut/get", {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load();
      });
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Data Atribut ${item.nama} yang telah di masukkan ke data user juga akan dihapus oleh sistem
          </div>
        </div>


        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.nama}<br>
        </div>

      `
      )
        .then(() => this.$store.dispatch("atribut/drop", { atribut_id: item.atribut_id, params: { kode_organisasi: this.organisasi_id }}))
        .then(() => {
          this.$info("Data berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  }
};
</script>
